import { Component, OnInit, Input, OnChanges, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DemoService } from 'src/app/demo.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-subject-service-resolution-outcome-type-modal',
  templateUrl: './subject-service-resolution-outcome-type-modal.component.html',
  styleUrls: ['./subject-service-resolution-outcome-type-modal.component.scss']
})
export class SubjectServiceResolutionOutcomeTypeModalComponent implements OnInit, OnChanges {

  @Input() actionType = ''; // 'create', 'edit'
  @Input() selectedId?: number;
  outcomeForm!: FormGroup;

  closeEvent = new EventEmitter<string>();

   constructor(private fb: FormBuilder, private demoService: DemoService,  public bsModalRef: BsModalRef) {


   }

  ngOnInit(): void {

 this.initForm();


 if (this.selectedId) {
      this.demoService.getSubjectServiceResolutionOutcomeTypesByType(this.selectedId).subscribe(data => {
        let res = data[0];
        this.outcomeForm.patchValue({
          subject_service_resolution_outcome_type_name: res.subject_service_resolution_outcome_type_name,
          subject_service_resolution_outcome_type_description: res.subject_service_resolution_outcome_type_description,
          is_active: res.is_active,
          sort_order: res.sort_order,
          subject_service_resolution_outcome_type_id: res.subject_service_resolution_outcome_type_id
        });
      });
    }

  }

 ngOnChanges() {
    
  }


  initForm() {
    this.outcomeForm = this.fb.group({
      subject_service_resolution_outcome_type_name: ['', Validators.required],
      subject_service_resolution_outcome_type_description: [''],
      is_active: [''],
      sort_order: [0],
      subject_service_resolution_outcome_type_id: ['']
    });
  }


saveOutcome(): void {
    const outcomeTypeData = {
      ...this.outcomeForm.value,
      is_active: this.outcomeForm.value.is_active ? 1 : 0
    };
    if (this.actionType === 'create') {
      this.demoService.createSubjectServiceResolutionOutcomeType(outcomeTypeData).subscribe(() => {
        // Refresh parent component or notify it to refresh
        this.closeEvent.emit('refresh');
        this.bsModalRef.hide();
      });
    } else if (this.actionType === 'edit') {
      this.demoService.updateSubjectServiceResolutionOutcomeType(this.selectedId!, outcomeTypeData).subscribe(() => {
        // Refresh parent component or notify it to refresh
        this.closeEvent.emit('refresh');
        this.bsModalRef.hide();
      });
    }
  }

  deleteOutcome(): void {
    const outcomeCount = this.demoService.getSubjectServiceResolutionOutcomeTypeOutcomesCount(this.selectedId!).toPromise();
    outcomeCount.then(count => {
      if (count === 0 && this.selectedId != 1 && this.selectedId != 2 ) {
        this.demoService.deleteSubjectServiceResolutionOutcomeType(this.selectedId!).subscribe(() => {
          // Refresh parent component or notify it to refresh
          this.closeEvent.emit('refresh');
          this.bsModalRef.hide();
        });
      } else {
        alert('Cannot delete type with associated outcomes. or primary or secondary Subject Service Outcome Resolution Types');
      }
    });
  }

  // deleteOutcome(): void {

  //     if (this.selectedId != 1 && this.selectedId != 2  ) {
  //       this.demoService.deleteSubjectServiceResolutionOutcomeType(this.selectedId!).subscribe(() => {
  //         // Refresh parent component or notify it to refresh
  //         this.closeEvent.emit('refresh');
  //         this.bsModalRef.hide();
  //       });
  //     } else {
  //       alert('Cannot delete type with associated outcomes.');
  //     }
  
  // }



  closeModal(): void {
    this.bsModalRef.hide();
  }


}
